<template>
  <form
    class="form-inline"
    @submit.prevent="">
    <fields
      :fields="fields.all()"
      :model="model"
      layout="inline"/>
    <b-button
      variant="light"
      type="button"
      @click.prevent="clear">Clear</b-button>
  </form>
</template>

<script>
import { FormMixin } from 'stylemix-base';
import debounce from 'lodash-es/debounce';

export default {
  name: 'BaseSearchForm',

  mixins: [FormMixin],

  props: {
    searchFields: { type: Array, default: () => {} },
  },

  data() {
    return {
      model: {},
    };
  },

  created() {
    this.setFields(this.searchFields);
    this.$watch('model', debounce(() => {
      this.$emit('submit', this.model);
    }, 500), { deep: true });
  },

  methods: {
    clear() {
      this.resetModel(this.model);
    },
  },
};
</script>
